// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"506":"9ae9d68b","648":"100d65d4"}[chunkId] + ".css";
};